jQuery( document ).ready(function() {
    
    // Check if component is added to the page
    if( jQuery('section.section-start').length ) {
        //wrap content into sections based on .section-start elements
        jQuery("section.section-start").each(function() {
            jQuery(this).nextUntil('.section-start').appendTo(jQuery(this));
        })
    }

});